module.exports = __webpack_public_path__ + "static/img/ent-detail-69.732996f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-69.jpg
// module id = wpGE
// module chunks = 52